import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { IconClose } from '../Icons';

import { StyledMySelectionsWrapper, StyledHeader, StyledH3, StyledClearAllButton, StyledListItem, StyledPriceCloseWrapper, StyledOutOfStock, StyledPrice, StyledCompareAtPrice, StyledClearButton, StyledMyTotalWrapper, StyledTotalLabel, StyledTotalPrice } from './VisualizerMySelectionsStyles';

var _ref = React.createElement(
  StyledH3,
  null,
  'THINGS I LOVE'
);

var _ref2 = React.createElement(
  StyledOutOfStock,
  null,
  'out of stock'
);

var _ref3 = React.createElement(IconClose, null);

var _ref4 = React.createElement(
  StyledTotalLabel,
  null,
  'TOTAL AMOUNT'
);

var VisualizerMySelections = function VisualizerMySelections(props) {
  var removeItem = function removeItem(prod) {
    props.handleProductSelection(prod);
  };

  var calculateTotalPrice = function calculateTotalPrice() {
    var total = 0;
    props.selectedProducts.forEach(function (product) {
      if (product.availableForSale) total += parseFloat(product.price);
    });
    return '$' + total.toFixed(2);
  };

  var formatPrice = function formatPrice(itemPrice) {
    return itemPrice ? parseFloat(itemPrice).toFixed(2) : 0;
  };

  return React.createElement(
    StyledMySelectionsWrapper,
    null,
    React.createElement(
      StyledHeader,
      null,
      _ref,
      props.selectedProducts.length > 0 && React.createElement(
        StyledClearAllButton,
        { onClick: function onClick() {
            return props.handleClearAll();
          } },
        'CLEAR ALL'
      )
    ),
    React.createElement(
      'ul',
      null,
      props.selectedProducts.map(function (selection) {
        var price = formatPrice(selection.price);
        var compareAtPrice = formatPrice(selection.compareAtPrice);
        var productSoldOut = !selection.availableForSale;

        return React.createElement(
          StyledListItem,
          {
            key: selection.variantId,
            productSoldOut: productSoldOut
          },
          React.createElement(
            'p',
            null,
            selection.parentTitle && selection.parentTitle
          ),
          React.createElement(
            StyledPriceCloseWrapper,
            null,
            productSoldOut ? _ref2 : React.createElement(
              Fragment,
              null,
              React.createElement(
                StyledPrice,
                null,
                '$',
                price
              ),
              compareAtPrice > price && React.createElement(
                StyledCompareAtPrice,
                null,
                '$',
                compareAtPrice
              )
            ),
            React.createElement(
              StyledClearButton,
              {
                'aria-label': 'Remove item',
                onClick: function onClick() {
                  return removeItem(selection);
                }
              },
              _ref3
            )
          )
        );
      })
    ),
    React.createElement(
      StyledMyTotalWrapper,
      null,
      _ref4,
      React.createElement(
        StyledTotalPrice,
        null,
        calculateTotalPrice()
      )
    )
  );
};

VisualizerMySelections.propTypes = {
  selectedProducts: PropTypes.array.isRequired,
  handleProductSelection: PropTypes.func.isRequired,
  handleClearAll: PropTypes.func.isRequired
};

export default VisualizerMySelections;